import classNames from "classnames";
import { ValueType } from "./interface";

export function getClassName(valueType: ValueType): string {
  return classNames('data-status', {
    'data-status-success': valueType === 'success',
    'data-status-error': valueType === 'error',
    'data-status-default': valueType === 'default',
    'data-status-processing': valueType === 'processing',
    'data-status-warning': valueType === 'warning',
    'data-status-add': valueType === 'add',
  });
};